import React, { useState } from 'react'

import { useTeamStaleWork } from '../hooks/useTeamStaleWork'
import { useTranslation } from 'react-i18next'

import { trackEvent } from '@/utils/analytics'
import { tVar } from '@/utils/i18n'

import { TEAM_STALE_WORK_ANALYTICS } from '../constants/constants'
import { StaleBannerView } from './StaleBannerView'
import { TeamStaleWorkModal } from './TeamStaleWorkModal'

/**
 * App-wide banner telling any user how many incidents anyone on the team
 * acknowledged over an hour ago that are still unresolved (ENG-32130: no
 * role gate; operators see the same program-wide view as PMs). The Review
 * button opens the team stale work modal (ENG-32131); the X snoozes the
 * banner for 24 hours (ENG-32181).
 */
export const TeamStaleWorkBanner = () => {
  const { t } = useTranslation()
  const { staleCount, isBannerVisible, dismiss, refetchCount, orgName } =
    useTeamStaleWork()
  const [isModalOpen, setIsModalOpen] = useState(false)

  const handleReviewClick = () => {
    trackEvent(TEAM_STALE_WORK_ANALYTICS.bannerClick, {
      stale_count: staleCount,
    })
    setIsModalOpen(true)
  }

  const handleModalClose = () => {
    setIsModalOpen(false)
    // Some (but not all) incidents may have been resolved from the list;
    // re-check the count now instead of at the next hourly tick.
    refetchCount()
  }

  return (
    <>
      {/* The copy interpolates the Org's name (ENG-32179); rendering before
          it resolves would show a literal {{orgName}} placeholder.
          isBannerVisible already waits on it; the orgName check narrows the
          type. */}
      {isBannerVisible && orgName ? (
        <StaleBannerView
          dismissAriaLabel={tVar(
            t,
            'incidents:stale_team_banner_dismiss_label',
            { orgName }
          )}
          message={tVar(t, 'incidents:stale_team_banner_message', {
            count: staleCount,
            orgName,
          })}
          onDismiss={dismiss}
          onPrimaryButtonClick={handleReviewClick}
          primaryButtonText={t('incidents:stale_team_banner_review')}
          testId='team-stale-work-banner'
        />
      ) : null}
      <TeamStaleWorkModal
        isOpen={isModalOpen}
        onAllResolved={refetchCount}
        onClose={handleModalClose}
        onResolved={refetchCount}
        orgName={orgName}
      />
    </>
  )
}
